import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import Search from "../Search";

interface Props {
  onSearch: (val: string) => void;
  query: string;
}

const ManageOutletHeader = ({ onSearch, query }: Props) => {
  const navigate = useNavigate();

  const navigateToAddMerchant = () => {
    navigate(`/admin/add-outlet`);
  };

  return (
    <StyledOutletHeader>
      <StyledPageHeader>Manage Outlet</StyledPageHeader>
      <OutletHeaderActions>
        <Search placeholder="Search" onChange={onSearch} value={query} />
        <Button
          variant="filled"
          label="Add Outlet"
          color={Colors.red}
          onClick={navigateToAddMerchant}
        ></Button>
      </OutletHeaderActions>
    </StyledOutletHeader>
  );
};

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledOutletHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 3.5rem;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0.5rem;
  }
`;

const OutletHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding: 1.5rem;
  }
`;
export default ManageOutletHeader;
